import { render, staticRenderFns } from "./footerP.vue?vue&type=template&id=4d398f90&scoped=true&"
import script from "./footerP.vue?vue&type=script&lang=js&"
export * from "./footerP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d398f90",
  null
  
)

export default component.exports